// extracted by mini-css-extract-plugin
module.exports = {"partner":"_25OCe","maskWrapper":"_3DAaX","actions":"_2eGnI","viewUserTimeSheet":"_32WmP","expandableCell":"_259yX","threeDotsButton":"_2N19Z","participantsTable":"_8gTkk"};